
import { Injectable,OnInit } from '@angular/core';
import { ApiService } from './api.service';
import {User} from '../models/data.types'
import { NavDropdownDirective } from 'app/directives';


export class NavigationCollection
{
   allUrls : NavigrationParentItem[]
   favoriteUrls : NavigrationParentItem[]
}

export class NavigrationParentItem
{
   isValid : boolean;
   name: string;
   url: string;
   icon:string;
   sequence: string;
   profileName: string;
   children : NavigrationChildItem[]
}

export class NavigrationChildItem
{
   name: string;
   url: string;
   icon:string;
   sequence: string;
   username: string;
   applicationid : string;
   isfavorite: string;
   profilemenuid :string;
   tab: boolean = true;
   type: string;
   system: string;
   menuid: string;
}


@Injectable()
export class MenuService {
  
  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  constructor(   private apiService: ApiService) {   }

   LoadUrls() :   Promise<NavigationCollection>  {
      let coll = new NavigationCollection();

      coll.allUrls = [];
      coll.favoriteUrls = [];


      let parameter : any = JSON.parse('{"username" : "'+this.currentUser.username+'" }');

    return this.apiService.postAs<any>('data/doquery/CW-GetPortalMenuItems',parameter)
        .then(response => {

            let allMenuItems : [any] = response.Items;

           let parentItems : any = this.uniqueBy(allMenuItems, function(x){return x.ParentName , x.ParentIcon , x.ParentSort;});

           parentItems.forEach(parentItem=> {


           let ParentMenuItem : NavigrationParentItem = 
                     {isValid : true, 
                      name : parentItem.ParentName,profileName:'' ,
                      url : parentItem.ParentRoute, 
                      icon :'icon-'+parentItem.ParentIcon,
                      children: this.ConvertToNavItem(parentItem,allMenuItems.filter(item => item.ParentName === parentItem.ParentName)).sort((item1, item2) =>{ 
                                    if (item1.sequence >item2.sequence) {
                                    return 1;
                                }
                
                                if (item1.sequence < item2.sequence) {
                                    return -1;
                                }   return 0; }),
                    sequence : parentItem.ParentSort}

            coll.allUrls.push(ParentMenuItem);

            let favParent : NavigrationParentItem  = new NavigrationParentItem();
            favParent.isValid = ParentMenuItem.isValid;
            favParent.name = ParentMenuItem.name;
            favParent.url = ParentMenuItem.url;
            favParent.icon = ParentMenuItem.icon;
            favParent.children = ParentMenuItem.children;
                                               
             let favSubMenuItems : NavigrationChildItem[] = favParent.children.filter(child => child.isfavorite === 'star') ;                                          

             if (favSubMenuItems.length > 0) {

                favParent.children = favSubMenuItems;

                coll.favoriteUrls.push(favParent)
             } 


            });
        return coll ;
       });   
     }


     
    uniqueBy(arr :Array<any>, fn :any) {
        var unique = {};
        var distinct = [];
        arr.forEach(function (x) {
        var key = fn(x);
        if (!unique[key]) {
            distinct.push(x);
            unique[key] = true;
        }
        });
        return distinct;
    }

    ConvertToNavItem (parentItem: any , subMenuItems : any) : NavigrationChildItem[] {

        let children : NavigrationChildItem[] = [];  
        
        subMenuItems.forEach(childElement => {

            let child : NavigrationChildItem;

            let applicationId :string  = '';
            if (childElement.Route.indexOf('?') > -1)
            {
                applicationId = childElement.Route.substring(childElement.Route.indexOf('=') +1 ,childElement.Route.length);
                
                childElement.Route = childElement.Route.substring(0,childElement.Route.indexOf('?'));
            }
            
            child = { 
                    name : childElement.Name, 
                    url : childElement.Route, 
                    icon :'', 
                    applicationid: applicationId ,
                    sequence : childElement.Sort,
                    isfavorite :  childElement.IsFavorite ? 'star' : 'star-o',
                    username :this.currentUser.username,
                    profilemenuid: '',
                    tab: null,
                    type: '',
                    system: parentItem.ParentName,
                    menuid : childElement.Id
                  }; 
                  children.push(child);
              });

        return children;

    }

  }





// WEBPACK FOOTER //
// ./src/app/services/menu.service.ts